/* Fransk katalog for locale-payroll-runs-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'pay.overview': 'Aperçu de la paie',
  'pay.overviewSub': 'Salaires enregistrés pour l’exercice, regroupés par salarié.',
  'pay.noPayBasis': 'Aucune base de paie pour l’instant',
  'pay.noPayBasisHint': 'L’aperçu s’affiche ici une fois les traitements de paie approuvés ou versés.',
  'pay.noPeriodsHint': 'Les cotisations patronales et le prélèvement à la source s’affichent dès que vous avez des traitements de paie approuvés.',
  'pay.noOtpBasisHint': 'La base de retraite s’affiche dès que vous avez des traitements de paie avec des montants de retraite.',
  'pay.noHolidayPayHint': 'La base de l’indemnité de congés payés s’affiche dès que vous avez des traitements de paie approuvés sur la période sélectionnée.',
  'pay.noPayslipsHint': 'Les bulletins de paie s’affichent dès que le traitement de paie comporte des salariés.',
  'pay.noInboxVouchersHint': 'Les justificatifs pas encore comptabilisés s’affichent ici.',
  'pay.noEntriesHint': 'Les justificatifs comptables s’affichent après l’approbation du traitement de paie.',
  'pay.noFixedLinesHint': 'Ajoutez des lignes de salaire fixes aux salariés pour les utiliser dans le traitement de paie.',
  'pay.salaryTypeSearchHintFull': 'Les types courants s’affichent en premier. Recherchez ou choisissez « Afficher plus » pour tout le catalogue actif.',
  'pay.overrideReasonSavedOnLineHint': 'Enregistré sur la ligne de salaire comme piste d’audit.',
  'pay.salaryTypeSearchHintRest': 'Les types courants s’affichent en premier. Recherchez ou choisissez « Afficher plus » pour le reste.',
  'pay.overrideReasonSavedOnFixedLineHint': 'Enregistré sur la ligne fixe.',
  'pay.payPeriodMonthOnlyHint': 'Les traitements de paie ne prennent en charge pour l’instant que des périodes mensuelles.',
  'pay.calculationCodeOtherHint': 'D’autres codes de calcul seront disponibles une fois implémentés et vérifiés.',
  'pay.runsAndEmployeesInline': '{{runs}} trait. de paie · {{employees}} salariés',
  'pay.fteShort': 'ETP :',
  'pay.taxShort': 'Impôt :',
  'pay.netShort': 'Net :',
  'pay.holidayPayShort': 'Congés p. :',
  'pay.agaShort': 'Cot. pat. :',
  'pay.withholdingHelp': 'Prélèvement à la source — l’impôt retenu sur le salaire brut et versé à l’État pour le compte du salarié.',
  'pay.holidayPayHelp': 'Indemnité de congés payés acquise — généralement 10,2 % de la base salariale. Versée l’année suivant son acquisition.',
  'pay.aga': 'Cotisations patronales',
  'pay.agaHelp': 'Cotisations patronales sur le salaire — une contribution que l’employeur verse à l’État en plus du coût salarial.',
  'pay.fpShort': 'Congés p. :',
  'pay.agaOfHolidayPay': 'Cot. pat. sur congés p.',
  'pay.agaOfHolidayPayHelp': 'Cotisations patronales calculées sur l’indemnité de congés payés acquise. Provisionnées au fur et à mesure de l’acquisition.',
  'pay.fte': 'Équivalents temps plein',
  'pay.fteHelp': 'Taux d’emploi converti en équivalents temps plein. 1,00 = temps plein, 0,50 = mi-temps.',
  'pay.overviewFilteredSub': 'Salaires enregistrés pour l’exercice, filtrés par date de versement.',
  'pay.grouping': 'Regroupement',
  'pay.perEmployee': 'Par salarié',
  'pay.perSalaryType': 'Par type de salaire',
  'pay.employeeAndType': 'Salarié et type de salaire',
  'pay.againstWithholding': 'Contre le prélèvement à la source',
  'pay.againstAga': 'Contre les cotisations patronales',
  'pay.postedAs': 'Comptabilisé ainsi :',
  'pay.postedWithholdingOnly': '{{tax}} contre 2600 prélèvement à la source. Restant avant paiement : {{openTax}}.',
  'pay.postedAgaOnly': '{{aga}} contre 2770 cotisations patronales. Restant avant paiement : {{openAga}}.',
  'pay.postedBoth': '{{tax}} contre 2600 prélèvement à la source et {{aga}} contre 2770 cotisations patronales. Restant avant paiement : {{openTax}} d’impôt et {{openAga}} de cotisations patronales.',
  'pay.autoPostedAgainstWithholding': 'Le paiement est comptabilisé automatiquement contre 2600 prélèvement à la source et crédite le compte de règlement sélectionné.',
  'pay.autoPostedAgainstAga': 'Le paiement est comptabilisé automatiquement contre 2770 cotisations patronales et crédite le compte de règlement sélectionné.',
  'pay.autoPostedAgainstBoth': 'Le paiement est comptabilisé automatiquement contre 2600 prélèvement à la source et 2770 cotisations patronales, et crédite le compte de règlement sélectionné.',
  'pay.agreedAnnualSalary': 'Salaire annuel convenu',
  'pay.agreedHourlyPay': 'Salaire horaire convenu',
  'pay.withholdingSeparatePaymentNote': 'Le prélèvement à la source sur les salaires versés à partir de 2026 est payé séparément, au plus tard le premier jour ouvrable suivant le versement de la paie.',
  'pay.recommendedForOtpPayment': 'Recommandé pour le paiement OTP',
  'pay.otpPaymentPostingNote': 'Le paiement est comptabilisé sur le compte de règlement sélectionné et utilisé par l’aperçu Retraite/OTP. La ligne bancaire peut ensuite être rapprochée du justificatif de paiement.',
  'pay.holidayPayAccruedLastYear': 'Indemnité de congés payés, acquise l’an dernier',
  'pay.holidayPayAccruedThisYear': 'Indemnité de congés payés, acquise cette année',
  'pay.ordinaryEmployment': 'Emploi ordinaire',
  'pay.payslipUncheckAllNote': 'Décochez tous les salariés si les bulletins de paie doivent être envoyés plus tard. Ils peuvent être envoyés depuis le traitement de paie après l’approbation de la comptabilisation.',
  'pay.payslipPdfNotConnected': 'Le PDF du bulletin de paie n’est pas connecté au backend.',
  'pay.noSalaryLines': 'Aucune ligne de salaire',
  'pay.deletedOn': 'Supprimé le {{date}}',
  'pay.payrollPaymentOn': 'Versement de la paie {{date}}',
  'pay.readyLinesForPayroll': '{{count}} lignes approuvées prêtes pour la paie ({{amount}}).',
  'pay.noReadyLinesForPayroll': 'Aucune ligne approuvée prête pour la paie.',
  'pay.overrideAppliesFutureRuns': 'Le remplacement s’applique aux futurs traitements de paie utilisant cette ligne fixe.',
  'pay.sentToLabel': 'est envoyé à',
  'pay.recommendedForPayrollPayment': 'Recommandé pour le versement de la paie',
  'pay.optionalNotePh': 'Note facultative ...',
  'pay.openWithholding': 'Prélèvement à la source restant',
  'pay.openAga': 'Cotisations patronales restantes',
  'pay.noPeriodPayments': 'Aucun paiement enregistré pour la période pour l’instant.',
  'pay.advance': 'Avance',
  'pay.agaAndWithholding': 'Cotisations patronales et prélèvement à la source',
  'pay.agaAndWithholdingSub': 'Suivez le prélèvement à la source et les cotisations patronales issus des traitements de paie approuvés, par période.',
  'pay.withholdingLongHelp': 'L’impôt que vous avez retenu sur le salaire des salariés. Il est conservé sur le compte de retenue fiscale et reversé à l’État — il ne vous appartient pas.',
  'pay.agaLongHelp': 'Contribution que l’employeur verse à l’État sur les salaires et avantages. Le taux dépend de la zone (commune) où se situe l’entreprise — 14,1 % en zone 1.',
  'pay.toAuthority': 'À Skatteetaten',
  'pay.toAuthorityHelp': 'Prélèvement à la source plus cotisations patronales — le montant total à payer à l’État pour la période.',
  'pay.noPeriods': 'Aucune période pour l’instant',
  'pay.period2': 'Période',
  'pay.payrollRunShort': 'Trait. paie',
  'pay.pensionOtp': 'Retraite / OTP',
  'pay.pensionOtpHelp': 'La retraite professionnelle obligatoire (OTP) est une épargne retraite légalement imposée pour les salariés — au moins 2 % du salaire. Ici, vous enregistrez et suivez les versements au prestataire de retraite issus des traitements de paie approuvés.',
  'pay.pensionPayments': 'Versements de retraite',
  'pay.pensionPaymentsSub': 'Enregistrez et suivez les paiements OTP issus des traitements de paie approuvés.',
  'pay.newPensionPayment': 'Nouveau versement de retraite',
  'pay.calculatedOtp': 'OTP calculée',
  'pay.calculatedOtpHelp': 'Total de la retraite professionnelle obligatoire calculée pour l’année, à partir des traitements de paie approuvés.',
  'pay.open2': 'Restant',
  'pay.unpaid': 'Impayé',
  'pay.unpaidOtpHelp': 'OTP calculée mais pas encore versée au prestataire de retraite.',
  'pay.otp': 'OTP',
  'pay.paidOtpHelp': 'OTP déjà versée au prestataire de retraite.',
  'pay.otpPaidWithDifference': 'Payé {{paid}} · écart {{difference}}',
  'pay.noOtpBasis': 'Pas encore de base OTP',
  'pay.payPeriod': 'Période de paie',
  'pay.pensionPayment': 'Versement retraite',
  'pay.otpRefPh': 'Ex. OTP-06',
  'pay.holidayPayList': 'Liste des indemnités de congés payés',
  'pay.holidayPayListSub': 'Indemnités de congés payés acquises et versées issues des traitements de paie approuvés.',
  'pay.holidayPayBasis': 'Base des indemnités de congés payés',
  'pay.earned': 'Acquis',
  'pay.noHolidayPay': 'Pas encore d\'indemnités de congés payés',
  'pay.paymentDate': 'Date de versement',
  'pay.holidayPayBasisHelp': 'Le total des salaires ouvrant droit à l\'indemnité de congés payés. L\'indemnité est calculée en pourcentage de cette base.',
  'pay.holidayPayEarnedHelp': 'Indemnités de congés payés acquises à ce jour — normalement 10,2 % de la base (12 % pour cinq semaines de congés). Versées l\'année suivant l\'acquisition.',
  'pay.holidayPayPaidHelp': 'Indemnités de congés payés déjà versées aux salariés cette année.',
  'pay.voucherShort': 'Justificatif :',
  'pay.paidOutShort': 'Versé :',
  'pay.earnedShort': 'Acquis :',
  'pay.paidShort': 'Versé :',
  'pay.salaryLine': 'Ligne de salaire',
  'pay.newLine': 'Créer une nouvelle ligne',
  'pay.taxResidentCountry': 'Résident fiscal du pays',
  'pay.earningCountry': 'Pays d\'activité',
  'pay.earningRelation': 'Relation de revenu',
  'pay.noPrefill': 'Ne pas préremplir le montant/la quantité de cette ligne dans les nouveaux traitements de paie',
  'pay.holidayPayPayout': 'Versement des indemnités de congés payés',
  'pay.addHolidayPay': 'Ajouter des indemnités de congés payés',
  'pay.earnedEarlier': 'Acquis précédemment',
  'pay.earnedThisYear': 'Acquis cette année',
  'pay.pensionContribution': 'Cotisation/prime de retraite',
  'pay.registerPensionContribution': 'Enregistrer une cotisation/prime de retraite',
  'pay.fetchNavRefunds': 'Récupérer les remboursements de NAV',
  'pay.fetchNavRefundsSub': 'Récupérez les remboursements à inclure dans le traitement de paie.',
  'pay.emailPayslips': 'Envoyer les bulletins de paie par e-mail',
  'pay.sendPayslips': 'Envoyer les bulletins de paie',
  'pay.sendLater': 'Envoyer plus tard',
  'pay.sendPayslip': 'Envoyer le bulletin de paie',
  'pay.sendAllPayslips': 'Envoyer à tous',
  'pay.sending': 'Envoi ...',
  'pay.payslipSendFailed': 'Impossible d\'envoyer le bulletin de paie.',
  'pay.payslipSendUnavailable': 'L\'envoi des bulletins de paie n\'est pas connecté au backend.',
  'pay.downloadPayslip': 'Télécharger le bulletin de paie',
  'pay.downloadAllPdf': 'Tout télécharger (PDF)',
  'pay.downloading': 'Téléchargement ...',
  'pay.sendTime': 'Heure d\'envoi',
  'pay.payslipsAfterPosting': 'Les bulletins de paie peuvent être téléchargés une fois le traitement de paie comptabilisé.',
  'pay.noPayslipsShort': 'Aucun bulletin de paie',
  'pay.paymentInfo': 'Informations de versement',
  'pay.copyToClipboard': 'Copier dans le presse-papiers',
  'pay.downloadExcel': 'Télécharger Excel',
  'pay.registerPayment': 'Enregistrer le versement',
  'pay.paymentsFromOperating': 'Versements depuis le compte d\'exploitation :',
  'pay.toBankAccount': 'Vers le compte bancaire',
  'pay.paidOutDate': 'Date de versement',
  'pay.bankTip': 'Astuce ! N\'oubliez pas d\'effectuer le paiement effectif du prélèvement à la source et des salaires dans votre banque en ligne.',
  'pay.linkVoucher': 'Lier un justificatif',
  'pay.noInboxVouchers': 'Aucun justificatif dans la boîte de réception',
  'pay.newSalaryLine': 'Nouvelle ligne de salaire',
  'pay.paidOutVerb': 'Versé le',
  'pay.agaShort2': 'AGA',
  'pay.holiday': 'Congés',
  'pay.noExtraLines': 'Aucune ligne de salaire supplémentaire n\'a encore été ajoutée.',
  'pay.showEmployeePage': 'Voir la page du salarié',
  'pay.addSalaryLine': 'Ajouter une ligne de salaire',
  'pay.noEmployeesInRun': 'Aucun salarié dans le traitement de paie',
  'pay.holidayPensionDeductions': 'Congés payés, retraite et retenues',
  'pay.pensionContributionOrPremium': 'Cotisation ou prime de retraite',
  'pay.summary': 'Récapitulatif',
  'pay.payrollRun': 'Traitement de paie',
  'pay.agaRate': 'Cotis. patronales (14,1 %)',
  'pay.posting': 'Comptabilisation',
  'pay.writeComment': 'Écrire un commentaire',
  'pay.seePayslips': 'Voir les bulletins de paie',
  'pay.nextStep': 'Étape suivante',
  'pay.sendAmeldingToAltinn': 'Envoyer l\'A-melding à Altinn',
  'pay.deletePayrollRun': 'Supprimer le traitement de paie',
  'pay.manualSubmission': 'Dépôt manuel',
  'pay.sendAmelding': 'Envoyer l\'A-melding',
  'pay.altinnConfirmation': 'Confirmation d\'Altinn',
  'pay.altinnConfirmationHelp': 'Une fois l\'A-melding envoyée, vous attendez la confirmation avant que les bulletins de paie soient créés.',
  'pay.createPayslips': 'Créer les bulletins de paie',
  'pay.editPayrollRun': 'Modifier le traitement de paie',
  'pay.registerPaymentToEmployees': 'Enregistrer le paiement aux salariés et des impôts',
  'pay.cancelPosting': 'Annuler la comptabilisation',
  'pay.cancelPostingConfirmTitle': 'Annuler la comptabilisation ?',
  'pay.cancelPostingConfirmMessage': 'Le traitement de paie repasse en brouillon. Les versements enregistrés et la comptabilisation elle-même sont annulés et retirés des chiffres comptables actifs. Vous devrez vérifier et valider la paie à nouveau.',
  'pay.cancelPostingConfirmAction': 'Annuler la comptabilisation',
  'pay.keepPosting': 'Conserver la comptabilisation',
  'pay.seeAccountingVoucher': 'Voir la pièce comptable',
  'pay.registerPayments': 'Enregistrer les versements',
  'pay.payrollDone': 'La paie est traitée et comptabilisée !',
  'pay.payrollDoneSub': 'Le traitement de paie est déclaré, comptabilisé et enregistré comme versé.',
  'pay.allPayrollRuns': 'Tous les traitements de paie',
  'pay.noEntries': 'Aucune écriture',
  'pay.calculatedWithholding': 'Prélèvement à la source calculé',
  'pay.toPayOut': 'À verser',
  'pay.activePayrollRuns': 'Traitements de paie actifs',
  'pay.runsCount': '{{count}} traitements',
  'pay.employeesInActiveRuns': '{{count}} salariés dans les traitements actifs',
  'pay.createNewRunHint': 'Créez un nouveau traitement de paie pour importer les salariés, les lignes de salaire fixes et les déplacements approuvés.',
  'pay.activePayrollRunsHelp': 'Un traitement de paie calcule le salaire, le prélèvement à la source, les indemnités de congés payés et les cotisations patronales pour une période. Les traitements actifs sont en cours.',
  'pay.newPayrollRun': 'Nouveau traitement de paie',
  'pay.noActiveRuns': 'Aucun traitement de paie actif',
  'pay.earlierPayrollRuns': 'Traitements de paie précédents',
  'pay.earlierPayrollRunsHelp': 'Traitements de paie dont le versement est enregistré. Vous pouvez les ouvrir pour voir les détails, les bulletins de paie et les pièces comptables.',
  'pay.orderNumberDate': 'Versement le plus récent d\'abord',
  'pay.travelAndExpenses': 'Déplacements et débours',
  'pay.createPayrollRun': 'Créer un nouveau traitement de paie',
  'pay.payrollRunDate': 'Date du traitement de paie',
  'pay.payPeriodMonthHelp': 'Le mois auquel se rapporte le salaire. La date de versement peut être différente.',
  'pay.paymentDateHelp': 'La date à laquelle l\'argent est effectivement versé. Elle ne modifie pas la période de paie.',
  'pay.paymentDatePeriodWarning': 'La date de versement se situe hors du mois habituel de la période de paie. Vérifiez que la période et la date sont correctes.',
  'pay.includeFixedLines': 'Inclure les lignes de salaire fixes',
  'pay.includeExpenseLines': 'Inclure les lignes de débours',
  'pay.readyExpenseLineCount': '{count} lignes prêtes à être versées',
  'pay.payPeriodLength': 'Période de paie (durée d\'acquisition)',
  'pay.ordinaryWithholding': 'Prélèvement à la source ordinaire',
  'pay.useTaxCard': 'Utiliser la carte fiscale si disponible',
  'pay.optionalComment': 'Commentaire facultatif',
  'pay.salaryTypesAndDeductions': 'Types de salaire et retenues',
  'pay.salaryTypesHelp': 'Les types de salaire déterminent le traitement d\'une ligne de salaire pour l\'AGA, le prélèvement à la source, les congés payés et la retraite.',
  'pay.newSalaryType': 'Nouveau type de salaire',
  'pay.agaLiableHelp': 'Indique si le type de salaire entre dans la base des cotisations patronales. Coché = soumis.',
  'pay.withholdingLiableHelp': 'Indique si le type de salaire est soumis à retenue — c\'est-à-dire si un prélèvement à la source doit être effectué sur le montant.',
  'pay.holidayPayLiableHelp': 'Indique si le type de salaire entre dans la base des congés payés — c\'est-à-dire si des indemnités de congés payés sont acquises sur le montant.',
  'pay.pension': 'Retraite',
  'pay.pensionLiableHelp': 'Indique si le type de salaire entre dans la base de la retraite professionnelle obligatoire (OTP).',
  'pay.rules': 'Règles',
  'pay.noLiabilityRules': 'Aucune règle de cotisation ou de retenue',
  'pay.noEffect': 'Aucun effet',
  'pay.bonusExamplePh': 'Ex. Prime sans congés payés',
  'pay.benefitInKind': 'Avantage en nature',
  'pay.deduction': 'Retenue',
  'pay.taxFreeAllowance': 'Indemnité non soumise à retenue',
  'pay.overrideNote': 'Les modifications sont enregistrées comme une personnalisation du type standard par l\'entreprise.',
  'pay.ratePerMonth': 'Taux (par mois)',
  'pay.calculated': 'Calculé',
  'pay.changeCountries': 'Modifier le pays d\'activité/de résidence',
  'pay.optionalCommentPh': 'Commentaire facultatif ...',
  'pay.fixedSalaryLines': 'Lignes de salaire fixes',
  'pay.fixedSalaryLinesSub': 'Lignes de salaire répétées automatiquement à chaque traitement de paie.',
  'pay.addFixedLine': 'Ajouter une ligne de salaire fixe',
  'pay.noFixedLines': 'Aucune ligne de salaire fixe',
  'pay.payrollSettings': 'Paramètres de paie',
  'pay.payrollSettingsSub': 'Valeurs par défaut utilisées lorsque Plumme comptabilise la paie, les cotisations patronales, les congés payés et la retraite.',
  'pay.contributionAndHoliday': 'Cotisations et congés payés',
  'pay.agaZone': 'Zone des cotisations patronales',
  'pay.holidayPayRate': 'Taux de congés payés',
  'pay.pensionOtpShort': 'Retraite (OTP)',
  'pay.pensionProvider': 'Prestataire de retraite',
  'pay.providerOrgNo': 'N° d\'org. du prestataire',
  'pay.otpRate': 'Taux OTP',
  'pay.accountsAndReporting': 'Comptes et déclarations',
  'pay.payrollAccount': 'Compte de paie (banque)',
  'pay.withholdingAccount': 'Compte de prélèvement fiscal',
  'pay.firstPayrollYear': 'Première année de comptabilisation de la paie',
  'pay.entityNumber': 'Numéro d\'établissement',
  'pay.holidayPayPercent': 'Pourcentage de congés payés',
  'pay.holidayPayPercentHelp': 'Taux auquel l\'indemnité de congés payés est acquise. 10,2 % est le minimum légal ; 12 % s\'applique en cas d\'accord sur cinq semaines de congés.',
  'pay.holidayPayMonth': 'Mois de versement des congés payés',
  'pay.month.january': 'Janvier',
  'pay.month.february': 'Février',
  'pay.month.march': 'Mars',
  'pay.month.april': 'Avril',
  'pay.month.june': 'Juin',
  'pay.month.july': 'Juillet',
  'pay.month.august': 'Août',
  'pay.month.september': 'Septembre',
  'pay.month.october': 'Octobre',
  'pay.month.november': 'Novembre',
  'pay.month.december': 'Décembre',
  'pay.shift.none': 'Pas de travail posté',
  'pay.shift.shift': 'Travail posté',
  'pay.shift.rota': 'Roulement',
  'pay.shift.continuous': 'Travail posté en continu',
  'pay.ordinary': 'Ordinaire',
  'pay.maritime': 'Maritime',
  'pay.freelancer': 'Indépendant',
  'pay.pensionOrOtherBenefit': 'Pension ou autre prestation',
  'pay.municipalityAndNumber': 'Commune et numéro de commune',
  'pay.pickMunicipality': 'Choisir une commune',
  'pay.calculationCode': 'Code de calcul',
  'pay.generalIndustries': 'Secteurs généraux',
  'pay.agricultureForestry': 'Agriculture et sylviculture',
  'pay.fishing': 'Pêche et chasse',
  'pay.pensionProviderOtp': 'Prestataire de retraite (OTP)',
  'pay.withholdingAccounts': 'Comptes de retenues',
  'pay.payoutAccount': 'Compte de versement des salaires',
  'pay.amelding': 'A-melding',
  'pay.everyMonth': 'Chaque mois',
  'pay.everyPayrollRun': 'À chaque traitement de paie',
  'pay.taxCardChangeAlert': 'Alerte en cas de modification de la carte fiscale',
  'pay.emailPh': 'nom@entreprise.fr',
  'pay.sms': 'SMS',
  'pay.savingsAccount': 'Compte d\'épargne',
  'pay.withholdingMode.fiftyPercent': '50 % de prélèvement à la source',
  'pay.withholdingMode.standardHint': 'Utilise la carte fiscale valide enregistrée pour le salarié. À défaut, 50 % sont prélevés.',
  'pay.withholdingMode.taxCardHint': 'Les cartes fiscales ne sont pas encore récupérées automatiquement auprès de Skatteetaten. Plumme utilise la carte fiscale enregistrée pour le salarié et prélève 50 % en l\'absence de carte valide.',
  'pay.withholdingMode.fiftyPercentHint': 'Prélève 50 % de la base de retenue pour tous les salariés de ce traitement de paie, quelle que soit la carte fiscale.',
  'pay.holidayPayPrevious.hint': 'Le montant acquis l\'an dernier est calculé à partir des traitements de paie approuvés de l\'an dernier, moins ce qui a déjà été versé. Les congés payés acquis avant l\'utilisation de Plumme ne sont pas inclus – ajustez le montant avec le crayon.',
  'pay.deductionAccount.label': 'Compte crédité de la retenue',
  'pay.deductionAccount.hint': 'Les retenues reversées à des tiers sont des dettes. Choisissez 2610 pour une saisie sur salaire. Plumme ne déclare pas les saisies sur salaire dans l\'A-melding – la retenue doit être reversée séparément.',
  'pay.deductionAccount.canteen': '5919 Retenue frais de cantine salariés',
  'pay.deductionAccount.garnishment': '2610 Saisie sur salaire',
  'pay.deductionAccount.unionDues': '2650 Cotisation syndicale retenue',
  'pay.deductionAccount.other': '2690 Autres retenues',
  'pay.taxRuleUnsupportedError': 'Plumme ne prend pas encore en charge {rule} – effectuez la paie de {employee} en dehors de Plumme.',
  'err.payroll.unsupportedTaxRule': 'Un salarié du traitement de paie relève d\'une règle fiscale que Plumme ne prend pas encore en charge. Effectuez la paie de ce salarié en dehors de Plumme.',
  'pay.taxRules.svalbard': 'Svalbard',
  'pay.taxRules.janMayen': 'Jan Mayen et les dépendances norvégiennes',
  'pay.taxRules.seafarerDeduction': 'la déduction spéciale pour les marins',
  'pay.taxRules.charity': 'organisation caritative ou d\'utilité publique',
  'pay.taxRules.netPay': 'salaire net',
  'pay.taxRules.netPaySeafarer': 'salaire net pour les marins',
  'pay.taxRules.pensionSourceTax': 'retenue à la source sur les pensions',
  'pay.taxRules.nanny': 'assistante maternelle au domicile de l\'enfant',
  'pay.taxRules.homeWork': 'travail salarié au domicile',
  'pay.taxRules.taxFreeOrganization': 'organisation exonérée d\'impôt',
  'pay.pensionAllocation.explain': 'La prime remplace l\'OTP calculée pour les salariés choisis. Si vous en choisissez plusieurs, le montant est réparti selon leur base OTP.',
  'pay.pensionAllocation.employees': 'Salariés concernés par la prime',
  'pay.pensionAllocation.amountRequired': 'Saisissez un montant supérieur à 0.',
  'pay.pensionAllocation.noEmployees': 'Choisissez au moins un salarié concerné par la prime.',
  'pay.pensionAllocation.noBasis': 'Les salariés choisis n\'ont pas de base OTP dans ce traitement de paie. Choisissez un salarié ou ajoutez d\'abord un salaire.',
  'pay.pensionAllocation.noLines': 'Le traitement de paie ne contient aucun salarié auquel rattacher la prime de retraite.',
  'pay.pensionAllocation.saveFailed': 'Impossible d\'enregistrer la prime de retraite.',
  'pay.travelNotPayableError': 'Ces notes de frais ou de déplacement ne peuvent plus être payées dans ce traitement de paie : {travels}. Elles ont déjà été payées dans un autre traitement ou ne sont pas approuvées. Retirez-les du brouillon ou contre-passez le traitement qui les a payées.',
  'err.payroll.travelNotPayable': 'Une note de frais ou de déplacement de ce traitement de paie a déjà été payée dans un autre traitement ou n\'est plus approuvée. Retirez la ligne du brouillon avant d\'approuver.',
  'pay.noCalculationBasis': 'Aucune base de calcul',
  'pay.payTypeGroup.common': 'Courants',
  'pay.payTypeGroup.custom': 'Types de salaire personnalisés',
  'pay.payTypeGroup.other': 'Autres types de salaire',
  'pay.payTypeGroup.benefitInKind': 'Avantages en nature',
  'pay.payTypeGroup.deduction': 'Retenues',
  'pay.payTypeGroup.taxFreeAllowance': 'Indemnités non imposables',
  'pay.inactive': 'inactif',
  'pay.selectSalaryType': 'Choisir un type de salaire',
  'pay.searchSalaryTypeOrRule': 'Rechercher un type de salaire ou une règle',
  'pay.showMoreSalaryTypes': 'Afficher plus de types de salaire',
  'pay.calculationRules': 'Règles de calcul',
  'pay.agaAndTaxTab': 'Cotisations patronales et impôt',
  'pay.pensionOtpTab': 'Retraite/OTP',
  'pay.zone': 'Zone',
  'pay.status.paid': 'Payé',
  'pay.status.unpaid': 'Non payé',
  'pay.status.approved': 'Approuvé',
  'pay.status.annulled': 'Annulé',
  'pay.status.draft': 'Brouillon',
  'pay.status.partiallyPaid': 'Partiellement payé',
  'pay.select': 'Choisir',
  'pay.search': 'Rechercher',
  'pay.noDataYet': 'Aucune donnée pour l\'instant',
  'pay.noDataYetBody': 'Les enregistrements s\'afficheront ici dès qu\'il y en aura.',
  'pay.notSet': 'Non défini',
  'pay.thisIsADeduction': 'Ceci est une retenue',
  'pay.fixedLineHint.payout': 'La ligne est versée au salarié',
  'pay.fixedLineHint.taxable': 'Soumis à retenue - inclus dans le prélèvement à la source',
  'pay.fixedLineHint.employerContribution': 'Inclus dans la base des cotisations patronales',
  'pay.fixedLineHint.holidayPay': 'Inclus dans la base des congés payés',
  'pay.fixedLineHint.pension': 'Inclus dans la base de la retraite (OTP)',
  'pay.fixedLineHint.deduction': 'Montant négatif - déduit du versement',
  'pay.amountMustBePositive': 'Le montant doit être supérieur à 0.',
  'pay.amountExceedsOpenTerm': 'Le montant ne peut pas dépasser le solde ouvert de la période.',
  'pay.allocationMustMatchAmount': 'La répartition doit correspondre au montant et ne peut pas dépasser les montants ouverts.',
  'pay.paymentUpdated': 'Paiement mis à jour.',
  'pay.paymentRegistered': 'Paiement enregistré.',
  'pay.savePaymentFailed': 'Impossible d\'enregistrer le paiement.',
  'pay.paymentAnnulled': 'Paiement annulé.',
  'pay.annulPaymentFailed': 'Impossible d\'annuler le paiement.',
  'pay.allPensionPaymentsRegistered': 'Tous les paiements de retraite sont enregistrés.',
  'pay.noOtpToRegisterYet': 'Aucune OTP calculée à enregistrer pour l\'instant.',
  'pay.missingPayrollRunForOtp': 'Traitement de paie manquant pour le paiement OTP.',
  'pay.pensionPaymentRegistered': 'Paiement de retraite enregistré.',
  'pay.registerPensionPaymentFailed': 'Impossible d\'enregistrer le paiement de retraite.',
  'pay.explainRuleOverrideRequired': 'Expliquez pourquoi les règles de calcul sont remplacées.',
  'pay.navRefundsFetched': 'Remboursements NAV récupérés.',
  'pay.navRefundsFetchFailed': 'Impossible de récupérer les remboursements auprès de NAV.',
  'pay.payslipDownloaded': 'Bulletin de paie téléchargé.',
  'pay.payslipDownloadFailed': 'Impossible de télécharger le bulletin de paie.',
  'pay.payslipsDownloaded': 'Bulletins de paie téléchargés.',
  'pay.payslipsDownloadFailed': 'Impossible de télécharger les bulletins de paie.',
  'pay.paymentInfoCopied': 'Informations de versement copiées.',
  'pay.paymentFileDownloaded': 'Fichier de versement téléchargé.',
  'pay.linkInboxDocumentFailed': 'Impossible de lier le justificatif de la boîte de réception.',
  'pay.payrollRunCreated': 'Versement de salaire créé.',
  'pay.payrollRunCreateFailed': 'Impossible de créer le versement de salaire.',
  'pay.payrollRunUpdateFailed': 'Impossible de mettre à jour le versement de salaire.',
  'pay.deletedPayrollRunRemoved': 'Versement de salaire supprimé retiré.',
  'pay.removePayrollRunFailed': 'Impossible de retirer le versement de salaire.',
  'pay.commentSaved': 'Commentaire enregistré.',
  'pay.salaryLineAdded': 'Ligne de salaire ajoutée.',
  'pay.voucherLinkedToPayrollRun': 'Justificatif lié au versement des salaires.',
});
